import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from '../../../../../../../core/shared/widget/widget-data';
import {FilterCriteria} from '../../../../../../../core/shared/filter/api/filter.criteria';
import {WidgetFactory} from '../../../../../../../core/shared/widget/service/widget.factory';
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from '../../../../../../../core/shared/helper/widget-function-call-back-create';

@Component({
    selector: 'bm-billing-area-payment-reminder-types',
    templateUrl: 'bm-billing-area-payment-reminder-types.component.html',
    standalone: false
})
export class BmBillingAreaPaymentReminderTypesComponent implements OnInit, OnChanges, OnDestroy {

    initialized: boolean = false;

    @Input() billingAreaId: number;

    paymentReminderTypesWidgetData: WidgetData;

    ngOnInit(): void {
        this.refreshComponent();
    }

    refreshComponent() {
        // PaymentReminderType.eligibleBillingArea is the FK (Java field: eligibleBillingArea,
        // DB column: eligible_billing_area_id). QL filter form: e.eligibleBillingAreaId.
        const filterCriteria = FilterCriteria.create(
            'e.eligibleBillingAreaId',
            FilterCriteria.cOperatorEqual,
            this.billingAreaId
        );

        this.paymentReminderTypesWidgetData = WidgetFactory.createWidgetTableEntityBasicQl(
            `bm.billing.area.payment.reminder.types.widget.data.${this.billingAreaId}`,
            'Zahlungserinnerungstypen',
            'bm.PaymentReminderType',
            [filterCriteria]
        );

        const fields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'eligibleBillingAreaDtoId', fieldValue: this.billingAreaId}
        ];
        this.paymentReminderTypesWidgetData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['billingAreaId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
